import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers, Reducer, ReducersMapObject } from "redux";
import { State } from "redux/state";

import { planReducer } from "../../api/modules/Plans";
import { authReducer } from "../../auth";
import { layoutReducer } from "../../layouts/AppLayout/modules/reducer";
import { orgReducer } from "../../routes/Organization/modules";

export const injectReducer = (history: History<any>, store: AsyncStore<State>, reducerMap: { key: string; reducer: Reducer<State> }) => {
    if (Object.hasOwnProperty.call(store.asyncReducers, reducerMap.key)) {
        return;
    }

    store.asyncReducers[reducerMap.key] = reducerMap.reducer;
    store.replaceReducer(makeRootReducer(history, store.asyncReducers));
};

export const makeRootReducer: (history: History<any>, reducerMap?: ReducersMapObject) => Reducer<State> = (
    history: History<any>,
    asyncReducers?: ReducersMapObject
) => {
    return combineReducers<State>({
        auth: authReducer,
        layout: layoutReducer,
        org: orgReducer,
        plan: planReducer,
        // this is correct, I just need to work out how to properly type it
        // @ts-ignore
        router: connectRouter(history),
        ...asyncReducers
    });
};

export default makeRootReducer;
